function defineColorByCriticalPath() {
  const gantt = window.to_use_react_gantt;
  gantt.config.highlight_critical_path = true;
}

export { defineColorByCriticalPath };
